import StatusDropdownFilter from 'components/elements/projectFilters/StatusDropdownFilter';
import { useDashboardStatus } from 'state/dashboard';

const StatusOverlayFilter = () => {
  const [status, setStatus] = useDashboardStatus();

  const onChangeStatusFilter = (_: any, newStatus: string) => {
    setStatus(newStatus);
  };

  const getCheckedValues = () => {
    if (status === 'active') {
      return ['active'];
    }
    if (status === 'completed') {
      return ['complete'];
    }
    if (status === '') {
      return ['active', 'complete'];
    }

    return [];
  };

  return (
    <StatusDropdownFilter
      value={getCheckedValues()}
      onChangeSelection={onChangeStatusFilter}
    />
  );
};

export default StatusOverlayFilter;
